import React from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';

export const sectionStyle = {
  maxWidth: '1200px',
  margin: '0 auto',
};

export const SectionTag: React.FunctionComponent = ({ children }) => {
  return (
    <section
      className={css(StyleSheet.create({ sectionStyle }).sectionStyle)}
    >
      {children}
    </section>
  );
};

export const Section = SectionTag;
